import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { startCase } from 'lodash'
import { DragVertical } from 'mdi-material-ui'
import { handleFormDrag } from 'actions/signupForm/addOrEdit'
import { Sortable } from '@progress/kendo-react-sortable'
import language from 'utils/vast-languagepack'

const getBaseItemStyle = (isActive) => ({
	cursor: 'move',
	background: isActive ? 'rgb(234, 249, 255, .5)' : null,
	border: isActive ? 'dashed 2px rgb(1, 76, .5)' : null,
	padding: 2,
})

const SortableItemUI = (props) => {
	const { isDisabled, isActive, style, attributes, dataItem, forwardRef } =
		props
	const classNames = ['col-xs-6 col-sm-3']

	if (isDisabled) {
		classNames.push('k-state-disabled')
	}

	return (
		<div
			id={dataItem.name}
			key={dataItem.name}
			ref={forwardRef}
			{...attributes}
			style={{
				...getBaseItemStyle(isActive),
				...style,
			}}
			className={classNames.join(' ')}
		>
			<h3
				style={{
					marginBottom: 0,
					fontSize: '18.72px',
					fontWeight: 'bold',
					display: 'block',
					marginBlockStart: '1em',
					marginBlockEnd: '1em',
					marginInlineStart: '0px',
					marginInlineEnd: '0px',
				}}
			>
				{startCase(dataItem.name)}
				{dataItem.required ? <span style={{ color: 'red' }}>*</span> : null}
			</h3>
			<input
				disabled={true}
				style={{
					width: isActive ? '91%' : '100%',
					border: 'solid 1px rgb(0,0,0,0.1)',
					padding: 8,
					fontSize: 20,
					marginBottom: 8,
					marginTop: 0,
					borderRadius: 35,
					background: 'white',
				}}
				type="text"
				id={`${dataItem.name}PreviewFieldID`}
				name={dataItem.name}
				required={dataItem.required}
			/>{' '}
			{isActive ? (
				<DragVertical
					style={{ fontSize: 20, color: 'rgb(0,0,0,.25)', marginTop: 8 }}
				/>
			) : null}
		</div>
	)
}

export default connect(
	(state) => ({ fields: state.signupForm.addOrEdit.fields }),
	(dispatch) => bindActionCreators({ handleFormDrag }, dispatch),
)(({ fields, handleFormDrag }) => {
	if (!fields) return <div>{language.signupform.add.chooseAField}</div>
	let fields_map = Object.keys(fields)
		.map((key) => {
			return {
				...fields[key],
				name: key,
			}
		})
		.sort((el) => el.idx)

	return (
		<div>
			<Sortable
				idField={'name'}
				data={fields_map}
				itemUI={SortableItemUI}
				animation={true}
				// onDragStart={function (event) {
				//   console.log('onDragStart:')
				//   console.log(event)
				// }}
				onDragOver={function (event) {
					// console.log('onDragOver:')
					// console.log(event)
					if (event.newState) {
						handleFormDrag(event.newState)
					}
				}}
				onNavigate={function (event) {
					// console.log('onNavigate:')
					// console.log(event)
					if (event.newState) {
						handleFormDrag(event.newState)
					}
				}}
			/>
		</div>
	)
})
